import React from "react";
import styles from "./confirmationTeenGame.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
import Post from "../post/post";

const ConfirmationTeenGame = ({message, choices, variables, abortFunction}) => {

  return (
    <div className={styles.wrapperConfirmation}>
      <div onClick={() => abortFunction(false)}  className={styles.overlayConfirmation}></div>

      <div className={styles.boxConfirmation}>

        <Post 
          message={message}
          isPlayerPost={true} additional_class={styles.playerPost}
          profilePic={variables.selected_profile ? ImgBuilder[`${variables.selected_profile}_small`] : ImgBuilder["LurksALot"]}
          profileName={variables.selected_profile ? variables.selected_profile : "LurksALot"}
        />

        <div className={styles.lowerConfirmation}>
          {choices.map((data, i) => (
            <button key={i} onClick={() => abortFunction(data.action)} className={`${styles.buttonConfirmation}`}>{data.text}</button>
          ))}
        </div>

      </div>
    </div>   
  );
};

export default ConfirmationTeenGame;
